export interface AnalyticsItem {
  item_name: string;
  price: number;
  quantity: number;
}
